angular.module('login')
.controller('GuestOrLoginController', ['$scope', '$stateParams', function ($scope, $stateParams) {
    $scope.pid = $stateParams.pid;
}]);


